<template>
  <div id="container">
    <span class="title">{{blog.title}}</span>
    <el-row class="userInfo">
      <el-avatar :size="30" :src="user.avatarurl" v-if="user.avatarurl"></el-avatar>
      <el-avatar :size="30" :src="require('@/assets/user_icon.jpeg')" v-else></el-avatar>
      <span class="username">{{user.nickname}}</span>
      <span class="time">{{blog.create_at}}</span>
    </el-row>
    <div v-for="(item, index) in blog.blog_desc" :key="index">
      <BlogDetailItem :item="item"></BlogDetailItem>
    </div>

    <div
      style="background: #FAFAFA; height: 6px;margin-top: 16px; margin-left: -12px; margin-right: -12px;"
    ></div>

    <div class="comment_header">
      <span
        style="background: #2497F7; width: 4px; height: 16px; margin-left: -12px; margin-right: 12px;"
      />
      <span style="color: #5C5C5C; font-size: 16px">全部评论（{{blog.commentcount}}）</span>
    </div>

    <div v-for="(comment) in comments" :key="comment.cid">
      <BlogComment :comment="comment"></BlogComment>
    </div>

 <router-link :to="{ name: 'Download'}">

   <div class="download_view_bottom">
   <el-image
          style="width: 100%; height: auto;"
          :src="require('@/assets/topbg.png')"
          fit="contain"
          lazy
        />


        <!-- <span style="color: #111111; font-size: 16px; padding: 10px 20px">智能算法+后台医生分析血压、心率、血脂、尿酸</span>
        <span style="color: #111111; font-size: 16px; padding: 10px 20px">在“圈子”页面可发帖问问题，只要连续记录1周数据，后台医生团队免费答疑</span> -->

    <div class="download_view">
      <!-- <el-image
          style="width: 50px; height: 50px;"
          :src="require('@/assets/app_icon.png')"
          fit="contain"
          lazy
        /> -->
      <div class="text_view" v-if="appBottom">
        <!-- <span class="title">撼高组</span>
        <span class="desc">撼高组</span> -->
        <span class="title">{{appBottom.app_bottom[0]}}</span>
        <span class="desc">{{appBottom.app_bottom[1]}}</span>
        <span class="desc">{{appBottom.app_bottom[2]}}</span>
         <!-- <span style="color: #111111; font-size: 16px; padding: 10px 20px">智能算法+</span>
        <span style="color: #111111; font-size: 16px; padding: 10px 20px"></span> -->
      </div>
      <div class="text_view" v-else>
        <span class="title">算法+医生共同分析，个体化建议</span>
        <span class="desc">健康数据永久保存不丢失，随时导出</span>
        <span class="desc">医生免费答疑，网友纯净交友</span>
      </div>


        <el-button type="primary" round size="small">下载撼高组</el-button>

    </div>
    </div>
    </router-link>
  </div>
</template>

<script>
// import Api from '@/network/Api';
import BlogDetailItem from "@/components/BlogDetailItem";
import BlogComment from "@/components/BlogComment";
import { v4 as uuidv4 } from 'uuid';

export default {
  name: "Detail",
  components: {
    BlogComment,
    BlogDetailItem
  },
  data() {
    return {
      reviewId: null,
      blog: {},
      user: {},
      comments: [],
      appBottom: null,
    };
  },
  watch: {
    $route(to, from) {
      //监听路由是否变化
      if (to.params.id && to.params.id != from.params.id) {
        this.reviewId = to.params.id;
        this.init(); //重新加载数据
      }
    }
  },
  created() {
    console.log(this.$route.params);
    this.reviewId = this.$route.params.id;
    this.init();
    this.deviceInfo();
  },
  methods: {
    init() {
      this.blog = {};
      this.user = {};
      this.comments = [];
      this.getCommunityDetail(this.reviewId);
      this.getBlogCommentList(this.reviewId);
      this.shareInfo();
    },
    async getCommunityDetail(reviewId) {
      if (!reviewId) {
        this.$message.error("参数传递错误");
        return;
      }
      let loadingInstance = this.$loading({
        fullscreen: true,
        text: "加载中...",
        background: "#80000000"
      });
      // let loadingInstance = Loading.service({ fullscreen: true });
      try {
        let ret = await this.$Api.getCommunityDetail(reviewId);
        this.blog = ret.data;
        this.user = ret.data.user;
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
      }

      // this.$Api.getCommunityDetail(reviewId,
      //   response => {
      //     console.log(response)
      //    loadingInstance.close();
      //     this.data = response.data
      //     this.user = response.data.user
      //   },
      //   error => {
      //     loadingInstance.close();
      //   })
    },
    async getBlogCommentList(reviewId) {
      let ret = await this.$Api.getBlogCommentList(reviewId);
      this.comments = ret.data.items;
    },
    async deviceInfo() {
      let uuid = localStorage.getItem('uuid');
      if (!uuid) {
        uuid = uuidv4();
        localStorage.setItem('uuid', uuid);
      }
      let params = new Object()
      params.device_uid = uuid
      params.device_type = 'web'
      params.api_version = "2.0"
      params.device_system_version = "2.0"
      await this.$Api.deviceInfo(params);
    },

    async shareInfo() {
      try {
        let ret = await this.$Api.shareInfo()  
        this.appBottom = ret.data.app_bottom
      } catch (error) {
        
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#container {
  padding: 4px;
  background: #ffffff;
  padding-bottom: 140px;
}
.title {
  font-size: 20px;
  color: #000000;
  font-weight: bold;
}
.userInfo {
  display: flex;
  align-items: center;
  margin: 10px 0px;
}
.userInfo .username {
  color: #2598f3;
  font-size: 14px;
  padding: 0px 10px;
}
.userInfo .time {
  color: #b7b8b9;
  font-size: 14px;
  padding-left: 10px;
}

.comment_header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 14px;
  padding-bottom: 14px;
}
.download_view_bottom{
  background: #fafafa;
  overflow: hidden;
  z-index: 9999;
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  flex-direction: column;
}
.download_view {
  /* background: rgba(255, 255, 255, 0.8);
  overflow: hidden;
  z-index: 9999;
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px; */
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-right: 10px;
  padding-left: 10px;
}
.download_view .text_view {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-left: 5px;
  padding-right: 5px;
}

.download_view .text_view .title{
  font-size: 14px;
}

.download_view .text_view .desc{
  font-size: 12px;
  padding-top: 2px;
  color: #111111;
}
</style>



// WEBPACK FOOTER //
// src/pages/community/Detail.vue